/*    
<summary>
  This functional component shows the customer details.
  Developer:Aashish Singh, Created Date: 20-March-2024
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../../contexts/StoreProvider";

import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { emptyValue } from "../../../constants/common-constant";
import { IClientList } from "../../../models/response/IClientResponse";
import AdminUser from "../../../assets/Images/user.svg";
import clientEmail from "../../../assets/Images/email.svg";
import call from "../../../assets/Images/call.svg";
import cancel from "../../../assets/Images/cancel.svg";
import accept from "../../../assets/Images/accept.svg";
import SpeedLimit from "../../../assets/Images/speed-limit.svg";
import alarm from "../../../assets/Images/alarm.svg";
import locationPin from "../../../assets/Images/location-pin.svg";
import gas from "../../../assets/Images/gas.svg";
import nozzel from "../../../assets/Images/nozzel.svg";
import driver from "../../../assets/Images/driver.svg";
import SpinnerLoader from "../../../shared-components/Loader/SpinnerLoader";

interface IProps {
  selectedData: IClientList | undefined;
}

const ClientDetails = (props: IProps) => {
  const { clientStore } = useStore();
  const { GetClientByIdService, getClientDetail, clientDetailState } = clientStore;

  /**
   * This function calls the "GetCustomerByIdService" store funtion that get group data from API
   */
  const callGetClientById = () => {
    if (props.selectedData) GetClientByIdService(props?.selectedData.Id);
  };

  useEffect(() => {
    if (props?.selectedData && props?.selectedData?.Id > 0) callGetClientById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.selectedData?.Id]);

  return (
    <React.Fragment>
      {clientDetailState.inProgress && <SpinnerLoader />}
      {getClientDetail && (
        <>
          {/* <Row className="mt-2 g-0">
            <Col xs={7}>
              <p className="text-break">
                {" "}
                <FormattedMessage id={"client_name"} />:{" "}
              </p>
            </Col>
            <Col className="text-end" xs={5}>
              <p className="text-break">{getClientDetail?.Name}</p>
            </Col>
            <Col className="text-end" xs={5}>
              <small className="text-break">{getClientDetail?.IsActive}</small>
            </Col>
          </Row> */}

          <Row className="border-bottom border-light">
            <h6 className="fw-semi-bold my-3 pb-3">Contact Person Details</h6>
            <Col lg="6">
              <div className="d-flex d-flex">
                <div>
                  <div className="circle-icon yellow">
                    <svg
                      fill="#0dcaf0"
                      viewBox="-42 0 512 512.001"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m210.351562 246.632812c33.882813 0 63.21875-12.152343 87.195313-36.128906 23.96875-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.128906 87.195312 23.980469 23.96875 53.316406 36.125 87.191406 36.125zm-65.972656-189.292968c18.394532-18.394532 39.972656-27.335938 65.972656-27.335938 25.996094 0 47.578126 8.941406 65.976563 27.335938 18.394531 18.398437 27.339844 39.980468 27.339844 65.972656 0 26-8.945313 47.578125-27.339844 65.976562-18.398437 18.398438-39.980469 27.339844-65.976563 27.339844-25.992187 0-47.570312-8.945312-65.972656-27.339844-18.398437-18.394531-27.34375-39.976562-27.34375-65.976562 0-25.992188 8.945313-47.574219 27.34375-65.972656zm0 0" />
                      <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.3125-10.339844-7.808594-20.550781-13.375-30.335938-5.769532-10.15625-12.550782-19-20.160157-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.042969 5.339844-10.96875 0-22.085937-1.796876-33.042968-5.339844-11.210938-3.621094-20.300782-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.753906-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.609375 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.0625 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.777344-1.023438 19.953125-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.4375 23.730469 65.066406 23.730469h246.53125c26.621094 0 48.511719-7.984375 65.0625-23.730469 16.757813-15.945312 25.253906-37.589843 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm-44.90625 72.828125c-10.933594 10.40625-25.449218 15.464844-44.378906 15.464844h-246.527344c-18.933594 0-33.449218-5.058594-44.378906-15.460938-10.722656-10.207031-15.933594-24.140625-15.933594-42.585937 0-9.59375.316406-19.066407.949219-28.160157.617187-8.921874 1.878906-18.722656 3.75-29.136718 1.847656-10.285156 4.199219-19.9375 6.996094-28.675782 2.683593-8.378906 6.34375-16.675781 10.882812-24.667968 4.332031-7.617188 9.316407-14.152344 14.816407-19.417969 5.144531-4.925781 11.628906-8.957031 19.269531-11.980469 7.066406-2.796875 15.007812-4.328125 23.628906-4.558594 1.050781.558594 2.921875 1.625 5.953125 3.601563 6.167969 4.019531 13.277344 8.605469 21.136719 13.625 8.859375 5.648437 20.273437 10.75 33.910156 15.152344 13.941406 4.507812 28.160156 6.796875 42.273437 6.796875 14.113282 0 28.335938-2.289063 42.269532-6.792969 13.648437-4.410156 25.058594-9.507813 33.929687-15.164063 8.042969-5.140624 14.953125-9.59375 21.121094-13.617187 3.03125-1.972656 4.902344-3.042969 5.953125-3.601563 8.625.230469 16.566406 1.761719 23.636719 4.558594 7.636719 3.023438 14.121093 7.058594 19.265625 11.980469 5.5 5.261719 10.484375 11.796875 14.816406 19.421875 4.542969 7.988281 8.207031 16.289062 10.886719 24.660156 2.800781 8.75 5.15625 18.398438 7 28.675782 1.867187 10.433593 3.132812 20.238281 3.75 29.144531v.007812c.636719 9.058594.957031 18.527344.960937 28.148438-.003906 18.449219-5.214844 32.378906-15.9375 42.582031zm0 0" />
                    </svg>
                  </div>
                </div>
                <div className="ps-3 fs-6 text-break">
                  <p className="mb-0"> Name</p>
                  <p className="fw-semi-bold">
                    {" "}
                    {getClientDetail?.ContactPersonName
                      ? getClientDetail.ContactPersonName
                      : emptyValue}
                  </p>
                </div>{" "}
              </div>
            </Col>
            <Col lg="6">
              <div className="d-flex d-flex">
                <div>
                  <div className="circle-icon purple">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      data-name="Layer 1"
                      viewBox="0 0 64 64"
                    >
                      <path d="M60.85,46.11a4.74,4.74,0,0,0-2.41-3L46.07,36.7a4.71,4.71,0,0,0-6,1.37l-2,2.74a.72.72,0,0,1-.93.21,36.3,36.3,0,0,1-8-6.17,36.31,36.31,0,0,1-6.17-8,.72.72,0,0,1,.21-.93l2.73-2a4.71,4.71,0,0,0,1.37-6L20.91,5.56A4.73,4.73,0,0,0,14.09,3.8L6.32,9A7.48,7.48,0,0,0,3,15.69a37.64,37.64,0,0,0,.89,6.57C6,30.4,11.09,38.77,18.16,45.85S33.61,58,41.75,60.09a37.67,37.67,0,0,0,6.57.89l.5,0A7.48,7.48,0,0,0,55,57.69l5.18-7.77A4.73,4.73,0,0,0,60.85,46.11Zm-4,1.58L51.7,55.47A3.5,3.5,0,0,1,48.58,57a34.57,34.57,0,0,1-5.83-.77C35.29,54.29,27.57,49.6,21,43S9.72,28.71,7.78,21.25A34.54,34.54,0,0,1,7,15.42a3.47,3.47,0,0,1,1.53-3.11l7.77-5.18a.71.71,0,0,1,.4-.12l.19,0a.72.72,0,0,1,.46.37l6.4,12.37a.73.73,0,0,1-.21.92l-2.73,2a4.72,4.72,0,0,0-1.28,6.13,40.54,40.54,0,0,0,6.8,8.81,40.52,40.52,0,0,0,8.81,6.8,4.72,4.72,0,0,0,6.13-1.28l2-2.74a.73.73,0,0,1,.92-.21l12.37,6.4a.73.73,0,0,1,.27,1.05Z" />
                    </svg>
                  </div>
                </div>
                <div className="ps-3 fs-6 text-break">
                  <p className="mb-0"> Phone No:</p>
                  <p className="fw-semi-bold">
                    {" "}
                    {getClientDetail?.ContactPersonPhoneNo
                      ? getClientDetail.ContactPersonPhoneNo
                      : emptyValue}
                  </p>
                </div>{" "}
              </div>
            </Col>
            <Col lg="12">
              <div className="d-flex d-flex">
                <div>
                  <div className="circle-icon blue">
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <g id="Layer_2" data-name="Layer 2">
                        <path d="m19 20.5h-14a4.00427 4.00427 0 0 1 -4-4v-9a4.00427 4.00427 0 0 1 4-4h14a4.00427 4.00427 0 0 1 4 4v9a4.00427 4.00427 0 0 1 -4 4zm-14-15a2.00229 2.00229 0 0 0 -2 2v9a2.00229 2.00229 0 0 0 2 2h14a2.00229 2.00229 0 0 0 2-2v-9a2.00229 2.00229 0 0 0 -2-2z" />
                        <path d="m12 13.43359a4.99283 4.99283 0 0 1 -3.07031-1.0542l-6.544-5.08984a1.00035 1.00035 0 0 1 1.22852-1.5791l6.54394 5.08984a2.99531 2.99531 0 0 0 3.6836 0l6.54394-5.08984a1.00035 1.00035 0 0 1 1.22852 1.5791l-6.544 5.08984a4.99587 4.99587 0 0 1 -3.07021 1.0542z" />
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="ps-3 fs-6 text-break">
                  <p className="mb-0">Email</p>
                  <p className="fw-semi-bold">
                    {" "}
                    {getClientDetail?.ContactPersonEmail
                      ? getClientDetail.ContactPersonEmail
                      : emptyValue}
                  </p>
                </div>{" "}
              </div>
            </Col>
          </Row>
          <Row className="border-bottom border-light">
            <h6 className="fw-semi-bold my-3 pb-3"><FormattedMessage id="client_address_info" /></h6>
            <Col lg="12">
              <div className="d-flex justify-content-start">
                <div>
                  <div className="circle-icon purple">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      data-name="Layer 1"
                      viewBox="0 0 64 64"
                    >
                      <path d="M60.85,46.11a4.74,4.74,0,0,0-2.41-3L46.07,36.7a4.71,4.71,0,0,0-6,1.37l-2,2.74a.72.72,0,0,1-.93.21,36.3,36.3,0,0,1-8-6.17,36.31,36.31,0,0,1-6.17-8,.72.72,0,0,1,.21-.93l2.73-2a4.71,4.71,0,0,0,1.37-6L20.91,5.56A4.73,4.73,0,0,0,14.09,3.8L6.32,9A7.48,7.48,0,0,0,3,15.69a37.64,37.64,0,0,0,.89,6.57C6,30.4,11.09,38.77,18.16,45.85S33.61,58,41.75,60.09a37.67,37.67,0,0,0,6.57.89l.5,0A7.48,7.48,0,0,0,55,57.69l5.18-7.77A4.73,4.73,0,0,0,60.85,46.11Zm-4,1.58L51.7,55.47A3.5,3.5,0,0,1,48.58,57a34.57,34.57,0,0,1-5.83-.77C35.29,54.29,27.57,49.6,21,43S9.72,28.71,7.78,21.25A34.54,34.54,0,0,1,7,15.42a3.47,3.47,0,0,1,1.53-3.11l7.77-5.18a.71.71,0,0,1,.4-.12l.19,0a.72.72,0,0,1,.46.37l6.4,12.37a.73.73,0,0,1-.21.92l-2.73,2a4.72,4.72,0,0,0-1.28,6.13,40.54,40.54,0,0,0,6.8,8.81,40.52,40.52,0,0,0,8.81,6.8,4.72,4.72,0,0,0,6.13-1.28l2-2.74a.73.73,0,0,1,.92-.21l12.37,6.4a.73.73,0,0,1,.27,1.05Z" />
                    </svg>
                  </div>
                </div>
                <div className="ps-3 fs-6 text-break">
                  <p className="mb-0"> Phone No:</p>
                  <p className="fw-semi-bold">
                    {" "}
                    {getClientDetail?.PhoneNo
                      ? getClientDetail.PhoneNo
                      : emptyValue}
                  </p>
                </div>{" "}
              </div>
            </Col>
            <Col lg="12">
              <div className="d-flex justify-content-start">
                <div>
                  <div className="circle-icon green">
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      viewBox="0 0 511.999 511.999"
                    >
                      <g>
                        <g>
                          <path
                            d="M409.124,63.426C368.224,22.525,313.843,0,256.001,0S143.777,22.525,102.877,63.426
			c-40.901,40.902-63.426,95.282-63.426,153.123c0,117.012,110.638,214.337,170.077,266.623c8.26,7.266,15.393,13.541,21.076,18.849
			c7.12,6.651,16.259,9.977,25.396,9.977c9.139,0,18.276-3.326,25.397-9.977c5.683-5.309,12.816-11.583,21.076-18.849
			c59.439-52.287,170.077-149.611,170.077-266.623C472.549,158.708,450.025,104.328,409.124,63.426z M282.663,460.654
			c-8.441,7.425-15.73,13.838-21.74,19.451c-2.761,2.577-7.085,2.578-9.847,0c-6.009-5.615-13.299-12.027-21.74-19.452
			c-55.88-49.155-159.895-140.654-159.895-244.103c0-102.868,83.689-186.557,186.558-186.557
			c102.868,0,186.557,83.689,186.557,186.557C442.557,319.999,338.543,411.498,282.663,460.654z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M256.001,112.938c-52.621,0-95.431,42.809-95.431,95.43s42.81,95.43,95.431,95.43s95.43-42.809,95.43-95.43
			S308.622,112.938,256.001,112.938z M256.001,273.805c-36.083,0-65.439-29.356-65.439-65.438s29.356-65.438,65.439-65.438
			s65.438,29.356,65.438,65.438S292.084,273.805,256.001,273.805z"
                          />
                        </g>
                      </g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                    </svg>
                  </div>
                </div>
                <div className="ps-3 fs-6 text-break">
                  <p className="mb-0">Address</p>
                  <p className="fw-semi-bold">
                    {" "}
                    {getClientDetail?.Address
                      ? getClientDetail.Address
                      : emptyValue}
                    ,{" "}
                    {getClientDetail?.City ? getClientDetail.City : emptyValue},{" "}
                    {getClientDetail?.State && 
                       `${getClientDetail.State}, `}
                    {getClientDetail?.Country
                      ? getClientDetail.Country
                      : emptyValue}
                  </p>
                </div>{" "}
              </div>
            </Col>
          </Row>

          <h6 className="fw-semi-bold mb-3 mt-3"><FormattedMessage id="client_setting_details" /></h6>
          <Row>
            <Col xs={6}>
              <div className="mb-0 d-flex">
                <div>
                  <div className="circle-icon yellow">
                    <span className="material-symbols-outlined">
                      calendar_month
                    </span>
                  </div>
                </div>
                <div className="h6 ps-3">
                  <p className="text-muted h6">
                    <FormattedMessage id="start_date" />
                  </p>
                  <p className="fw-semi-bold">
                    {" "}
                    {getClientDetail.StartDate
                      ? getClientDetail.StartDate
                      : emptyValue}
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={6}>
              <div className="mb-0 d-flex">
                <div>
                  <div className="circle-icon purple">
                    <span className="material-symbols-outlined">
                      calendar_month
                    </span>
                  </div>
                </div>
                <div className="h6 ps-3">
                  <p className="text-muted h6">
                    <FormattedMessage id="end_date" />
                  </p>
                  <p className="fw-semi-bold">
                    {" "}
                    {getClientDetail.EndDate
                      ? getClientDetail.EndDate
                      : emptyValue}{" "}
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="limit bg-light py-3 mt-2">
            <Col xs={6}>
              <p className="text-break">
                <img
                  src={getClientDetail?.EnableLimitSettings ? accept : cancel}
                  alt="alarm"
                  className="enabled-client pe-1"
                />
                <span className="ps-1">
                  <FormattedMessage id="limit_enabled" />{" "}
                </span>
              </p>
            </Col>
            <Col xs={6}>
              <p className="text-break">
                <img
                  src={
                    getClientDetail?.EnableFuelSensorSettings
                      ? accept
                      : cancel
                  }
                  alt="alarm"
                  className="enabled-client pe-1"
                />
                <span className="ps-1">
                  <FormattedMessage id="fuel_sensor_enabled" />
                </span>
              </p>
            </Col>
            <Col xs={6}>
              <p className="text-break">
                <img
                  src={getClientDetail?.EnableGpsSettings ? accept : cancel}
                  alt="alarm"
                  className="enabled-client pe-1"
                />
                <span className="ps-1">
                  <FormattedMessage id="gps_enabled" />
                </span>
              </p>
            </Col>
            <Col xs={6}>
              <p className="text-break">
                <img
                  src={
                    getClientDetail?.EnableDriverIdSettings ? accept : cancel
                  }
                  alt="alarm"
                  className="enabled-client pe-1"
                />
                <span className="ps-1">
                  <FormattedMessage id="driver_id_enabled" />
                </span>
              </p>
            </Col>
            <Col xs={6}>
              <p className="text-break">
                <img
                  src={
                    getClientDetail?.EnableNozzleRfidSetting ? accept : cancel
                  }
                  alt="alarm"
                  className="enabled-client pe-1"
                />
                <span className="ps-1">
                  <FormattedMessage id="nozzle_rfid_enabled" />{" "}
                </span>
              </p>
            </Col>
            <Col xs={6}>
              <p className="text-break">
                <img
                  src={getClientDetail?.EnableAlarmSettings ? accept : cancel}
                  alt="alarm"
                  className="enabled-client pe-1"
                />
                <span className="ps-1 d-flex-inline">
                  <FormattedMessage id="alarm_enabled" />{" "}
                </span>
              </p>
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  );
};

export default observer(ClientDetails);
